import contentState from './content';
import disctionaryState from './dictionary';
import mainState from './main';
import timeState from './time';
import settingsState from './settings';

const States = {
  contentState,
  disctionaryState,
  mainState,
  settingsState,
  timeState,
};

export default States;
